export default async ({ $api, store }) => {
  await $api('util/amounts').then(amounts => store.commit('utils/setAmounts', amounts));
};
